import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';

import ApplyCSS from '../../../components/ApplyCSS';
import commonUtil from '../../../utils/commonUtil';

import AppEvents from '../../App/AppEvents';

import * as labelsActions from '../../../components/labels/actions';
import * as getGlobleObject from '../../../components/globleObject/reducer';
import * as landingPageActions from './actions';
import * as allowedEventTypesActions from '../AllowedEventTypes/action';
import * as EventCategoryActions from '../../../components/eventcategory/actions';
import * as createEventObject from '../../createEvent/actions';

import serverClientUtil from '../../../utils/serverClientUtil';
import Tagging from '../../../components/Tagging';
import MarketingContentSection from '../MarketingContentSection';
import CSSWrapper from '../../../components/ApplyCSS/CSSWrapper';
import { loadEventDetails } from '../../../components/EventDetails/actions';
import VozCliente from '../../../components/VozCliente';

const applicationRoutes = commonUtil.getApplicationRoutes();

const { isContentLoaded, loadContent } = landingPageActions;
const { isAllowedEventTypesLoaded, loadAllowedEventTypes } =
  allowedEventTypesActions;

const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;

const pageName = 'grHomepage';
const cms_page_id = 'liverpool-homepage';

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isContentLoaded(getState())) {
        return dispatch(loadContent(cms_page_id));
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isEventCategoryLoaded(getState())) {
        return dispatch(loadEventCategoryEvent());
      }
      return undefined;
    },
  },
  // {
  //   promise: ({ store: { dispatch, getState } }) => {
  //     if (!isCreateEventDataLoaded(getState(), pageName)) {
  //       return dispatch(defineCreateEventData('SelectMesaType', ''));
  //     }
  //     return undefined;
  //   },
  // },
])
@connect(
  (store) => ({
    store: store,
    content: store.getMarketingLandingPage.data,
    lables: store.labels.data,
    error: store.labels.error,
    loading: store.labels.loading,
    extraData: store.labels.extraData,
    globleObj: store.globleObject,
    eventCategoryType: store.eventcategory.data,
    createEventObjectData: store.createEventObject.data,
    allowedEventTypes: store.allowedEventTypes.data,
  }),
  {
    ...landingPageActions,
    ...labelsActions,
    ...getGlobleObject,
    ...createEventObject,
     loadEventDetails
  },
)
class MesaHomePage extends Component {
  constructor(props) {
    super(props);
    this.wapBackButtonEvent = null;
    this.state = {
      showModal: false,
      route: '/',
      eventName: '',
    };
  }

  static propTypes = {
    lables: PropTypes.object,
  };

  componentDidMount() {
    this.homepageBindclickEvent();
    this.wapBackButtonEvent = AppEvents.subscribe(
      AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED,
    );
    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [
        this.changeComponentOnBackButtonClick,
      ]);
    }
    const _dataLayer = this.getTaggingData();
    this.tagging.applyGTM('Home', _dataLayer);

    if (typeof document !== 'undefined' && document) {
      const btn = document.querySelector('.route-link');
      if (btn) {
        btn.addEventListener('click', this.handleSearchClick);
      }
    }
    this.props.loadAllowedEventTypes();

    AppEvents.hookEvent(AppEvents.EVENT_REGISTER.GIFT_LIST_BACK_BUTTON_CLICKED, this.handleGiftListBack);
    this.giftListBackButtonEvent = AppEvents.subscribe(
      AppEvents.EVENT_REGISTER.GIFT_LIST_BACK_BUTTON_CLICKED,
    );
    
    if (this.giftListBackButtonEvent && commonUtil.getChannel() === 'wap') {
        AppEvents.publish(this.giftListBackButtonEvent, [this.handleGiftListBack]);
    }
    
    
  }


  handleGiftListBack = () => {
    commonUtil.getChannel() === 'wap' && this.props.loadEventDetails();
  };

  componentWillUnmount() {
     AppEvents.unsubscribe(this.wapBackButtonEvent);
     AppEvents.unsubscribe(this.giftListBackButtonEvent);
    if (typeof document !== 'undefined' && document) {
      const btn = document.querySelector('.route-link');
      if (btn) {
        btn.removeEventListener('click', this.handleSearchClick);
      }
    }
  }

  changeComponentOnBackButtonClick = () => {
    const _url = serverClientUtil.getLPFullURL();
    window.location.href = _url;
  };

  getTaggingData = () => {
    const _dataLayer = {};
    _dataLayer.category = 'Home';
    _dataLayer.dimension8 = 'Home';
    if (
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.profileId
    ) {
      _dataLayer.userId =
        this.props.user.result.gtmUserId || this.props.user.result.profileId;
    } else {
      _dataLayer.userId = 'c7a5e24a9625b485cba934747972557f';
    }
    return _dataLayer;
  };

  getTaggingData2 = () => {
    const dataLayer = {};
    dataLayer.event = 'vPageview';
    dataLayer.actPageTitle = 'Home Mesa de Regalos';
    dataLayer.actURL = window.location.href;
    dataLayer.loginStatus = 'N';
    dataLayer.profileID = '';
    dataLayer.userID = '';
    if (
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.profileId
    ) {
      dataLayer.profileID = this.props.user.result.profileId;
      dataLayer.userID =
        this.props.user.result.gtmUserId || this.props.user.result.profileId;
    } else {
      dataLayer.userID = 'c7a5e24a9625b485cba934747972557f';
    }
    return dataLayer;
  };

  homepageBindclickEvent = () => {
    // handle click events on home page...
    if (typeof document !== 'undefined' && document && browserHistory) {
      if (document.querySelector('.tutorialBlock .btnPrimary')) {
        document.querySelector('.tutorialBlock .btnPrimary').addEventListener(
          'click',
          () => {
            browserHistory.push(applicationRoutes.mesaType);
          },
          false,
        );
      }
    }
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  handleCreateGiftTableButtonClick = async (button) => {
    this.setState({
      showModal: true,
      route: button.route,
      eventName: button.name,
    });
  };

  handleSearchClick = () => {
    browserHistory.push(applicationRoutes.searchEvent);
  };

  render() {
    const { lables, content, store } = this.props;
    return (
      <React.Fragment>
        <Tagging ref={(tagging) => (this.tagging = tagging)} />
        <VozCliente page="home" />
        <CSSWrapper pageName={pageName} title={content?.title} />
        <MarketingContentSection contentSection={content} store={store} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  lables: state.labels.data,
  user: state.user.data,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ getGlobleObject, loadAllowedEventTypes }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(MesaHomePage);
